/**
 * Slack Options cadence allow-list (TRD §7.1): 5–59 minutes plus 1–8 hours.
 */
const HOUR_MINUTES = [60, 120, 180, 240, 300, 360, 420, 480] as const;

function minutesRange(): number[] {
  const values: number[] = [];
  for (let minutes = 5; minutes <= 59; minutes += 1) {
    values.push(minutes);
  }
  return values;
}

export const ALLOWED_CADENCE_MINUTES: readonly number[] = [...minutesRange(), ...HOUR_MINUTES];

export function isAllowedCadenceMinutes(minutes: number): boolean {
  return ALLOWED_CADENCE_MINUTES.includes(minutes);
}

export type CadenceUnit = 'minutes' | 'hours';

export function minutesToCadenceFields(minutes: number): { value: number; unit: CadenceUnit } {
  if (minutes >= 60) {
    return { value: Math.floor(minutes / 60), unit: 'hours' };
  }
  return { value: minutes, unit: 'minutes' };
}

/**
 * Converts Options-style value + unit to stored minutes, or null if not on the allow-list.
 */
export function cadenceFieldsToMinutes(value: string | number, unit: CadenceUnit): number | null {
  const raw = typeof value === 'string' ? value.trim() : value;
  if (raw === '') {
    return null;
  }
  const parsed = typeof raw === 'number' ? raw : Number(raw);
  if (!Number.isInteger(parsed)) {
    return null;
  }
  const minutes = unit === 'hours' ? parsed * 60 : parsed;
  return isAllowedCadenceMinutes(minutes) ? minutes : null;
}

export function formatCadenceMinutes(minutes: number): string {
  if (minutes < 60) {
    return minutes === 1 ? 'Every 1 minute' : `Every ${minutes} minutes`;
  }
  const hours = minutes / 60;
  return hours === 1 ? 'Every 1 hour' : `Every ${hours} hours`;
}
